export class UserRole {
    public readonly roleId: number;
    public readonly roleName: string;
    public readonly roleAbbreviation: string;

    private constructor(
        roleId: number,
        roleName: string,
        roleAbbreviation: string
    ) {
        this.roleId = roleId;
        this.roleName = roleName;
        this.roleAbbreviation = roleAbbreviation;
    }

    public static Administrator = new UserRole(
        50,
        "Administrator",
        "Administrator"
    );
    public static Accounting = new UserRole(80, "Accounting", "Acc");
    public static ClientAdmin = new UserRole(30, "Client Admin", "CA");
    public static Client = new UserRole(35, "Client", "Client");
    public static Sourcer = new UserRole(20, "Sourcer", "Sourcer");
    public static Lead = new UserRole(5, "Lead", "Lead");
    public static Networker = new UserRole(10, "Networker", "Networker");
    public static Recruiter = new UserRole(40, "Recruiter", "Recruiter");

    public static asArray = () => [
        UserRole.Administrator,
        UserRole.Accounting,
        UserRole.Client,
        UserRole.ClientAdmin,
        UserRole.Sourcer,
        UserRole.Lead,
        UserRole.Networker,
        UserRole.Recruiter,
    ];

    public static fromId = (roleId: number) =>
        UserRole.asArray().find(t => t.roleId === roleId);

    public static fromName = (roleName: string) =>
        UserRole.asArray().find(t => t.roleName === roleName);

    public static stakeholders = [
        UserRole.Networker,
        UserRole.Sourcer,
        UserRole.Recruiter,
        UserRole.Administrator,
    ];

    public static referredByStakeholders = [
        UserRole.Networker,
        UserRole.Sourcer,
        UserRole.Recruiter,
        UserRole.Administrator,
    ];

    public static managedByStakeholders = [
        UserRole.Recruiter,
        UserRole.Administrator,
    ];

    public static managers = [UserRole.Recruiter, UserRole.Administrator];
    public static administrators = [UserRole.Administrator];
}
